import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { getCurrentLanguage } from "@/hooks/use-language.ts";
import { setToken } from "@/hooks/use-token.ts";
import { resetFeatureFlags } from "@/lib/runtime-config.ts";
import { format } from "date-fns";
import {
  endTrackedSession,
  getTrackedSessionState,
  restoreTrackedSessionState,
} from "./kiosk-session-tracking";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number | string, currency: string) {
  return currency === "HUF" || currency === "Ft"
    ? amount + " Ft"
    : amount + " €";
}

export async function resetKiosk(options?: {
  preserveTracking?: boolean;
  endReason?: string;
}) {
  const trackedSession = options?.preserveTracking
    ? getTrackedSessionState()
    : null;

  if (!options?.preserveTracking) {
    await endTrackedSession(options?.endReason);
  }

  sessionStorage.clear();
  restoreTrackedSessionState(trackedSession);
  localStorage.removeItem("user");
  localStorage.removeItem("payment");
  setToken(null);
  resetFeatureFlags();
}

export function formatDate(date: Date) {
  const lang = getCurrentLanguage();
  return format(
    date,
    lang === "hu"
      ? "yyyy. MM. dd"
      : lang === "en"
        ? "MM/dd/yyyy"
        : lang === "de"
          ? "dd.MM.yyyy"
          : "MM/dd/yyyy",
  );
}
